import { SagaIterator } from 'redux-saga';
import { call, put, select, takeEvery } from 'redux-saga/effects';

import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Location } from '~commonInfra/utils/Location';
import { Tableau } from '~commonInfra/utils/TableauLog';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { CancelBackgroundJob, NavigateToBackgroundJobTaskDetails, OpenCancelBackgroundJobDialog, ToggleBackgroundJobExtendedInfoDialog } from '../../bootstrap/redux/actions/AppActionTypes';
import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { CancelBackgroundJobAction } from '../actions/CancelBackgroundJobAction';
import { NavigateToBackgroundJobTaskDetailsAction } from '../actions/NavigateToBackgroundJobTaskDetailsAction';
import { OpenCancelBackgroundJobDialogAction } from '../actions/OpenCancelBackgroundJobDialogAction';
import { ToggleBackgroundJobExtendedInfoDialogAction } from '../actions/ToggleBackgroundJobExtendedInfoDialog';
import { BackgroundJobExtendedInfoDialog } from '../components/BackgroundJobExtendedInfoDialog';
import { CancelBackgroundJobDialog } from '../components/CancelBackgroundJobDialog';
import { BackgroundJobsService } from '../types/BackgroundJobs';
import { ICancelBackgroundJobParams } from '../types/CancelBackgroundJobRequest';
import { buildTaskDetailsUrl } from '../utils/BackgroundJobUrls';


export function* openCancelBackgroundJobDialog(action: OpenCancelBackgroundJobDialogAction): SagaIterator {
  try {
    yield call(CancelBackgroundJobDialog.open, action.backgroundJob);
  } catch (e) {
    yield put(requestFailed(e, Messages.backgroundJobCancelFailed()));
  }
}

export async function cancelBackgroundJobAsyncHelper(params: ICancelBackgroundJobParams) {
  return await BackgroundJobsService.cancelBackgroundJob(params);
}

export function popToastNotificationForBackgroundJobCancellation(sucessfull: boolean) {
  const service = ToasterService.instance;
  if (sucessfull) {
    service.pop({
      text: Messages.backgroundJobCancelSuccessful(),
      type: ToastType.Info,
    });
  } else {
    service.pop({
      text: Messages.backgroundJobCancelFailed(),
      type: ToastType.Error,
    });
  }
}

export function* cancelBackgroundJob(action: CancelBackgroundJobAction): SagaIterator {
  const result: IResult = yield call(cancelBackgroundJobAsyncHelper, action.params);
  const errored = result.errors && result.errors.length > 0;
  yield call(popToastNotificationForBackgroundJobCancellation, !errored);
  yield put(requestSpaceContents());
}

export function* toggleBackgroundJobExtendedInfoDialog(action: ToggleBackgroundJobExtendedInfoDialogAction): SagaIterator {
  yield call(BackgroundJobExtendedInfoDialog.toggle, action.backgroundJob);
}

export function* navigateToBackgroundJobTaskDetails(action: NavigateToBackgroundJobTaskDetailsAction): SagaIterator {
  const { backgroundJob } = action;
  if (!backgroundJob.taskLuid) {
    return;
  }
  const urls: SpacesSiteUrls = yield select(siteUrlsSelector);
  if (!urls) {
    Tableau.Logger().warn('[BackgroundJobSagas] siteUrlsSelector returned null, cannot navigate to task details');
    return;
  }
  Location.instance.setUrl(buildTaskDetailsUrl(urls.jobsUrl(), backgroundJob.taskLuid, backgroundJob.jobId));
}

export function* rootBackgroundJobSaga(): SagaIterator {
  yield takeEvery(OpenCancelBackgroundJobDialog, openCancelBackgroundJobDialog);
  yield takeEvery(CancelBackgroundJob, cancelBackgroundJob);
  yield takeEvery(ToggleBackgroundJobExtendedInfoDialog, toggleBackgroundJobExtendedInfoDialog);
  yield takeEvery(NavigateToBackgroundJobTaskDetails, navigateToBackgroundJobTaskDetails);
}
